import React, { useState, useEffect } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { FaProjectDiagram, FaMoneyBillWave } from 'react-icons/fa';
import { PropagateLoader } from 'react-spinners';

import BreadCrumb from '~/components/BreadCrumb';
import DefaultInput from '~/components/Inputs/Default';
import Pagination from '~/components/Pagination';
import SelectButton from '~/components/Buttons/Select';

import api from '~/services/api';

import { Container, Table, Td } from './styles';

const AMOUNT_PER_PAGE = 5;

const ListRepresentatives: React.FC = () => {
  const history = useHistory();
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [filter, setFilter] = useState('');
  const [representatives, setRepresentatives] = useState<
    {
      code: string;
      name: string;
    }[]
  >([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const checkEnabledFunctionality = async () => {
      await api.get('/generalsettings').then(response => {
        if (response.data && !response.data.new_sponsorship_req_enabled) {
          history.push('/');
        }
      });
    };

    checkEnabledFunctionality();
  }, [history]);

  useEffect(() => {
    const loadRepresentatives = async () => {
      await api
        .get(
          `/representatives/paginate?` +
            `page=${page}&` +
            `filter=${filter}&` +
            `amount=${AMOUNT_PER_PAGE}`,
        )
        .then(response => {
          setRepresentatives(response.data[0]);
          setCount(response.data[1]);
          setLoading(false);
        });
    };

    loadRepresentatives();
  }, [page, filter]);

  return (
    <Container style={{ minHeight: 600 }}>
      <BreadCrumb
        main="Solicitações"
        path="/projects/main"
        firstChildPath="/projects/sponsorships"
        firstChild="Pagamentos"
        secondChild="Nova Solicitação"
        mainIcon={FaProjectDiagram}
        firstChildIcon={FaMoneyBillWave}
        secondChildIcon={FaMoneyBillWave}
        mainColored
        firstChildColored
      />

      <div style={{ width: '100%', maxWidth: 512 }}>
        <DefaultInput
          name="search"
          labelText="Pesquisar"
          type="text"
          onChange={event => {
            setFilter(event.target.value);
            setPage(0);
          }}
        />
      </div>

      <Table>
        <thead>
          <tr>
            <th style={{ width: '20%', textAlign: 'left' }}>Código</th>
            <th style={{ width: '60%', textAlign: 'left' }}>Representante</th>
            <th style={{ width: '20%', textAlign: 'center' }} />
          </tr>
        </thead>

        <tbody>
          {loading ? (
            <tr>
              <Td colSpan={3} style={{ padding: '3rem', textAlign: 'center' }}>
                <PropagateLoader color="#276c8d" />
              </Td>
            </tr>
          ) : representatives.length > 0 ? (
            representatives.map(rep => (
              <tr key={rep.code}>
                <Td
                  style={{ width: '20%', textAlign: 'left' }}
                  heading="CÓDIGO"
                >
                  {rep.code}
                </Td>
                <Td
                  style={{ width: '60%', textAlign: 'left' }}
                  heading="REPRESENTANTE"
                >
                  {rep.name}
                </Td>
                <Td
                  style={{
                    width: '20%',
                    display: 'flex',
                    textAlign: 'center',
                  }}
                  heading={' '}
                >
                  <Link
                    to={{
                      pathname: `/projects/sponsorships/procedure1/client`,
                      state: rep,
                    }}
                  >
                    <SelectButton />
                  </Link>
                </Td>
              </tr>
            ))
          ) : (
            <tr>
              <Td colSpan={3} style={{ textAlign: 'center' }}>
                Nenhuma informação disponível
              </Td>
            </tr>
          )}
        </tbody>
      </Table>

      <div style={{ marginTop: '2rem' }}>
        <Pagination
          page={page}
          count={count}
          amountPerPage={AMOUNT_PER_PAGE}
          setPage={setPage}
        />
      </div>
    </Container>
  );
};

export default ListRepresentatives;
